import {
  h,
  Component,
  ComponentChildren,
  ComponentChild,
  ErrorInfo,
  Fragment,
} from "preact";

interface Props {
  children: ComponentChildren;
}

interface State {
  error: string | null;
  stackTrace?: string | null;
}

/**
 * Class based component for catching / handling errors
 */
class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    error: null,
    stackTrace: null,
  };

  // Lifecycle error catching
  public static getDerivedStateFromError(error: Error): State {
    return { error: error.message, stackTrace: error.stack };
  }
  // Lifecycle error catching
  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    // TODO: Send error to AirBrake
  }

  renderFormattedStack(): ComponentChild {
    try {
      const lines = this.state.stackTrace?.split("\n");
      return (
        <Fragment>
          {lines?.map((line, i) => (
            <p key={`line-${i}`}>{line}</p>
          ))}
        </Fragment>
      );
    } catch (e) {
      // if the split fails on string or string is undefined
      return this.state.stackTrace || "Stack trace unavailable";
    }
  }

  renderDevError() {
    if (process.env.NODE_ENV === "development") {
      return (
        <div class="ErrorBoundary-devContainer">
          <p class="ErrorBoundary-title">{`Error: ${this.state.error}`}</p>
          <div class="ErrorBoundary-stack">{this.renderFormattedStack()}</div>
        </div>
      );
    }
  }

  public render() {
    if (this.state.error) {
      return (
        <div class="ErrorBoundary-publicError">
          <div>Could not load the Access Player</div>
          {this.renderDevError()}
        </div>
      );
    }

    // TODO: Fallback Component for other envs defined by design
    return this.props.children;
  }
}

export default ErrorBoundary;
